import React, { useState, useContext, useEffect, useRef } from "react";
import {
  Button,
  CloseButton,
  Portal,
  SimpleGrid,
  Dialog,
  Tabs,
  Text,
  Input,
  Field,
  Box,
  Textarea,
  Badge,
  Icon,
  createListCollection,
  Select,
  Card,
  HStack,
  Collapsible,
  Separator,
  Timeline,
  Avatar,
  Span,
  Spinner,
  Stack,
  Image,
  Slider,
  Popover,
} from "@chakra-ui/react";
import {
  LuPlus,
  LuCheck,
  LuTimer,
  LuText,
  LuInfo,
  LuDownload,
  LuTimerOff,
  LuLogs,
  LuCoins,
  LuLoader,
  LuSparkle,
  LuLayoutList,
  LuRuler,
  LuFolders,
  LuFocus,
  LuFolderDown,
  LuCirclePlay,
  LuFilter,
  LuArrowUp,
  LuArrowDown,
  LuTowerControl,
  LuScrollText,
  LuSendHorizontal,
  LuMessageSquareText,
  LuRefreshCcw,
  LuSquareCheck,
  LuShieldQuestion,
  LuTimerReset,
  LuCirclePlus,
  LuDiamondPlus,
  LuCheckCheck,
  LuSquareCheckBig,
  LuHourglass,
} from "react-icons/lu";
import { useAppStore } from "../../../../context/store";
import { floatingStyles, formatISODateSimple, getFileTypeFromUrl, ReviewTitleOptions, showToast, truncateWords } from "../../../../utilies/Utility";
import { Tooltip } from "./../../../ui/tooltip";
import Type from "../../../../utilies/Types";
import { deleteDrawingForSelect, enableRectangleDrawing } from "../../../../utilies/GlobalToolsUtility";
import { serviceAddTask, serviceGetTask } from "../../../../api/services/task";
import { showBBoxOnMap } from "../../../../utilies/ProjectUtility";

import { serviceAddLog } from "../../../../api/services/log";
import TaskManagementNewTask from "./TaskManagementNewTask";
import TaskManagementDailyReport from "./TaskManagementDailyReport";
import { serviceComment } from "../../../../api/services/comment";
import { loadProjectLayers } from "../../../../utilies/loader/project/LoadProject";
import { useMapObjects } from "../../../../context/MapObjectsContext";

const TaskCard = ({ data, status, reportDialogState, getTasks }) => {
  // state

  const viewerRef = useAppStore((s) => s.viewerRef);
  const projects = useAppStore((s) => s.projects);
  const userType = useAppStore((s) => s.userType);
  const userData = useAppStore((s) => s.userData);
  const selectedTask = useAppStore((s) => s.selectedTask);
  const tasks = useAppStore((s) => s.tasks);
  const loadingDataForLayers = useAppStore((s) => s.loadingDataForLayers);
  const originalCameraControls = useAppStore((s) => s.originalCameraControls);
  const defaultGeojsonStyle = useAppStore((s) => s.defaultGeojsonStyle);
  const basicGeojsonStyle = useAppStore((s) => s.basicGeojsonStyle);
  const defaultOsmStyle = useAppStore((s) => s.defaultOsmStyle);
  const selectedProject = useAppStore((s) => s.selectedProject);

  // setters
  const setSelectedProject = useAppStore.getState().setSelectedProject;
  const setIsAdminTaskListOpen = useAppStore.getState().setIsAdminTaskListOpen;
  const setIsOpenAddonsMenu = useAppStore.getState().setIsOpenAddonsMenu;
  const setCurrentTask = useAppStore.getState().setCurrentTask;
  const setSelectedTask = useAppStore.getState().setSelectedTask;
  const setTasks = useAppStore.getState().setTasks;
  const setUserCanEditing = useAppStore.getState().setUserCanEditing;
  const setUserType = useAppStore.getState().setUserType;
  const setPointCloudStyle = useAppStore.getState().setPointCloudStyle;
  const { mapObjects, setMapObjects, mapObjectsRef } = useMapObjects();
  const setMapObjectsAssest = useAppStore.getState().setMapObjectsAssest;
  const setImageGeojson = useAppStore.getState().setImageGeojson;
  const setImageGeojsonSelected = useAppStore.getState().setImageGeojsonSelected;
  const setImageGeojsonMode = useAppStore.getState().setImageGeojsonMode;
  const setImageDataSource = useAppStore.getState().setImageDataSource;
  const setImageGeojsonCounter = useAppStore.getState().setImageGeojsonCounter;

  const [commentInput, setCommentInput] = useState("");

  const [openReplies, setOpenReplies] = useState({});
  const toggleReplies = (key) => setOpenReplies((p) => ({ ...p, [key]: !p[key] }));

  const [startingTaskId, setStartingTaskId] = useState(null);

  const startTask = (item) => {
    setStartingTaskId(item.id);

    serviceAddTask(
      {
        data: JSON.stringify({
          status: "in_progress",
        }),
        task_id: item.id,
      },
      userData.token
    )
      .then((res) => {
        if (res.data.status === "success") {
          showToast(res.data.message, Type.NOTIFICATION.SUCCESS);
          for (const key in projects) {
            if (projects[key].id == item.project.id) {
              setSelectedProject(projects[key]);
              loadProjectLayers({
                project: projects[key],
                viewerRef,
                userData,
                setUserType,
                setUserCanEditing,
                loadingDataForLayers,

                // map / point cloud setters
                setPointCloudStyle,
                setMapObjects,
                setMapObjectsAssest,

                // image geojson setters
                setImageGeojson,
                setImageGeojsonSelected,
                setImageGeojsonMode,
                setImageDataSource,
                setImageGeojsonCounter,

                // styles / controls
                originalCameraControls,
                defaultGeojsonStyle,
                basicGeojsonStyle,
                defaultOsmStyle,
              });
              setIsAdminTaskListOpen(false);
              setIsOpenAddonsMenu(true);
              break;
            }
          }
          getTasks();
        }
      })
      .catch((err) => {
        console.error("Error", err);
      })
      .finally(() => {
        setStartingTaskId(null);
      });
  };

  const addCommentLog = (item) => {
    const formData = new FormData();
    formData.append(
      "data",
      JSON.stringify({
        task_id: item.id,
        context: commentInput,
        log_type: "comment",
      })
    );

    serviceAddLog(formData, userData.token)
      .then((res) => {
        if (res.data.status === "success") {
          showToast(res.data.message, Type.NOTIFICATION.SUCCESS);
          setCommentInput("");
          getTasks();
        } else {
          showToast(res.data.message, Type.NOTIFICATION.WARNING);
        }
      })
      .catch((err) => {
        console.error("Error", err);
        showToast(err.message, Type.NOTIFICATION.ERROR);
      });
  };

  const reloadTaskById = (item) => {
    setRefreshingTaskId(item.id); // start spinner
    let serviceData = {};
    let temp = { task_id: item?.id };
    serviceData.params = JSON.stringify(temp);

    serviceGetTask(serviceData, userData.token)
      .then((res) => {
        if (res.data.status === "success") {
          const updatedTasks = tasks.map((task) => {
            const newTask = res.data.tasks.find((t) => t.id === task.id);
            return newTask ? newTask : task;
          });
          setTasks(updatedTasks);
        } else {
          showToast(res.data.message, Type.NOTIFICATION.WARNING);
        }
      })
      .catch((err) => {
        console.error("Error", err);
        showToast(err, Type.NOTIFICATION.ERROR);
      })
      .finally(() => {
        setRefreshingTaskId(null); // stop spinner
      });
  };

  const [openLogs, setOpenLogs] = useState({});
  const toggleLog = (idx) => {
    setOpenLogs((prev) => ({ ...prev, [idx]: !prev[idx] }));
  };

  const [refreshingTaskId, setRefreshingTaskId] = useState(null);

  const normalizeReplies = (replies) => {
    const out = [];
    const visit = (v) => {
      if (!v) return;
      if (Array.isArray(v)) return v.forEach(visit);
      if (typeof v === "object") {
        // looks like a reply
        if ("context" in v && ("timestamp" in v || "date" in v || "created_at" in v)) {
          out.push({
            id: v.id ?? undefined, // can be undefined; use index as fallback key
            username: v.username ?? v.user ?? v.author ?? "unknown",
            context: String(v.context ?? ""),
            timestamp: v.timestamp ?? v.date ?? v.created_at ?? "",
          });
        }
        // traverse nested fields
        Object.values(v).forEach(visit);
      }
    };
    visit(replies);
    return out;
  };

  const [replyInputs, setReplyInputs] = useState({});

  // simple submit handler; replace body with your API
  const handleSubmitReply = (parentId, text, taskId) => {
    const formData = new FormData();
    formData.append(
      "data",
      JSON.stringify({
        task_id: taskId,
        context: text,
        log_type: "reply",
        task_log_id: parentId,
      })
    );

    serviceAddLog(formData, userData.token)
      .then((res) => {
        if (res.data.status === "success") {
          showToast(res.data.message, Type.NOTIFICATION.SUCCESS);
          setReplyInputs((p) => ({ ...p, [currentReplyKeyRef.current]: "" }));
          getTasks();
        } else {
          showToast(res.data.message, Type.NOTIFICATION.WARNING);
        }
      })
      .catch((err) => {
        console.error("Error", err);
        showToast(err.message, Type.NOTIFICATION.ERROR);
      });
  };

  // optional: keep last key to clear easily
  const currentReplyKeyRef = useRef(null);

  // track loading state by unique key (review.id + status)
  const [reviewLoading, setReviewLoading] = useState({});

  const handleReviewStatus = async (review, status) => {
    const key = `${review.id}_${status}`; // unique key per button
    setReviewLoading((p) => ({ ...p, [key]: true }));

    const temp = {
      review_id: review.id,
      status,
    };

    try {
      const res = await serviceComment({ data: JSON.stringify(temp) });

      if (res.data.status === "success") {
        showToast(res.data.message, Type.NOTIFICATION.SUCCESS);
      } else {
        showToast(res.data.message, Type.NOTIFICATION.WARNING);
      }
    } catch (err) {
      console.error("Error", err);
      showToast(err.message, Type.NOTIFICATION.ERROR);
    } finally {
      setReviewLoading((p) => ({ ...p, [key]: false }));
    }
  };

  return (
    <>
      {data
        .filter((item) => item.status === status)
        .sort((a, b) => new Date(b.modified) - new Date(a.modified))
        .map((item, index) => (
          <Card.Root overflow="hidden" maxW="xl" my={1} key={index}>
            <Box>
              <Box position={"absolute"} top={"4px"} right={"0px"} direction={"rtl"}>
                <HStack gap={2} pr={2} pt={2}>
                  <Button
                    display={"contents"}
                    bg={"transparent"}
                    p={0}
                    m={0}
                    onClick={() => {
                      showBBoxOnMap(viewerRef.current, item.bbox);
                    }}
                  >
                    <Tooltip content={"Show Bbox"}>
                      <LuFocus color="MenuText" size={"25px"} />
                    </Tooltip>
                  </Button>

                  {!selectedProject && (
                    <Button
                      bg={"transparent"}
                      display={"contents"}
                      p={0}
                      m={0}
                      onClick={() => {
                        if (!item.project) {
                          showToast("Project not set for this task", Type.NOTIFICATION.WARNING);
                          return;
                        }
                        for (const key in projects) {
                          if (projects[key].id == item.project.id) {
                            setSelectedProject(projects[key]);
                            loadProjectLayers({
                              project: projects[key],
                              viewerRef,
                              userData,
                              setUserType,
                              setUserCanEditing,
                              loadingDataForLayers,

                              // map / point cloud setters
                              setPointCloudStyle,
                              setMapObjects,
                              setMapObjectsAssest,

                              // image geojson setters
                              setImageGeojson,
                              setImageGeojsonSelected,
                              setImageGeojsonMode,
                              setImageDataSource,
                              setImageGeojsonCounter,

                              // styles / controls
                              originalCameraControls,
                              defaultGeojsonStyle,
                              basicGeojsonStyle,
                              defaultOsmStyle,
                            });
                            setIsAdminTaskListOpen(false);
                            setIsOpenAddonsMenu(true);
                            break;
                          }
                        }
                      }}
                    >
                      <Tooltip content={"Load Project"}>
                        <LuFolderDown color="MenuText" size={"25px"} />
                      </Tooltip>
                    </Button>
                  )}

                  {userType.includes("annotator") && item.status == "open" && (
                    <Button
                      display={"contents"}
                      bg={"transparent"}
                      p={0}
                      m={0}
                      onClick={() => {
                        startTask(item);
                      }}
                      isDisabled={startingTaskId === item.id}
                    >
                      <Tooltip content={"Start Task"}>{startingTaskId === item.id ? <Spinner size="sm" color="green" /> : <LuCirclePlay color="green" size={"25px"} />}</Tooltip>
                    </Button>
                  )}

                  {userType.includes(Type.ROLE.ANNOTATOR) ||
                    (userType.includes(Type.ROLE.SUPER_ADMIN) && item.status == "in_progress" && (
                      <Button
                        display={"contents"}
                        bg={"transparent"}
                        p={0}
                        m={0}
                        onClick={() => {
                          reportDialogState[1](true);
                          setCurrentTask(item);
                        }}
                      >
                        <Tooltip content={"Daily Report"}>
                          <LuScrollText color="MenuText" size={"25px"} />
                        </Tooltip>
                      </Button>
                    ))}
                  <Button
                    display={"contents"}
                    bg={"transparent"}
                    p={0}
                    m={0}
                    onClick={() => {
                      reloadTaskById(item);
                    }}
                    isDisabled={refreshingTaskId === item.id}
                  >
                    <Tooltip content={"Refresh"}>{refreshingTaskId === item.id ? <Spinner size="sm" color="MenuText" /> : <LuRefreshCcw color="MenuText" size={"25px"} />}</Tooltip>
                  </Button>
                </HStack>
              </Box>
              <Card.Body p={2} bg={selectedTask?.id == item.id ? "green.100" : "transparent"}>
                <Card.Title
                  mb="1"
                  cursor={"pointer"}
                  onClick={() => {
                    setSelectedTask(item);
                  }}
                >
                  <HStack>
                    {item.status == "open" && <LuDiamondPlus size={"25px"} />}
                    {item.status == "in_progress" && <LuLoader size={"25px"} />}
                    {item.status == "review" && <LuHourglass size={"25px"} />}
                    {item.status == "completed" && <LuSquareCheckBig size={"25px"} />}
                    <Text width={"250px"} fontSize={"15px"} lineHeight={"short"}>
                      {item.title ? item.title : "No Title"}{" "}
                    </Text>
                  </HStack>
                </Card.Title>
                <Separator mt={1} mb={2} />

                <HStack>
                  <LuTimer /> <Text>Start: {formatISODateSimple(item.start_date)}</Text>
                </HStack>
                <HStack>
                  <LuTimerOff /> <Text>End: {formatISODateSimple(item.end_date)}</Text>
                </HStack>
                <HStack>
                  <LuTimerReset /> <Text>Last Edit: {formatISODateSimple(item.modified)}</Text>
                </HStack>
                <HStack>
                  <LuRuler /> <Text>Size: {item.length}</Text>
                </HStack>
                <HStack>
                  <LuCoins /> <Text>Token: {item.token}</Text>
                </HStack>
                <HStack>
                  <LuFolders /> <Text>Porject Name: {item?.project?.project_name}</Text>
                </HStack>
                <HStack alignItems="flex-start">
                  <HStack>
                    <LuFolders />
                    <Text>Contributors:</Text>
                  </HStack>

                  <Stack direction="row" flexWrap="wrap" gap={1}>
                    {item.contributors.map((role, index) => (
                      <Badge key={index} variant="outline">
                        {role}
                      </Badge>
                    ))}
                  </Stack>
                </HStack>

                <Collapsible.Root mt={2}>
                  <Collapsible.Trigger cursor={"pointer"} bg={"blackAlpha.800"} p={1} px={2} color={"white"} borderRadius={"lg"} mb={2}>
                    <HStack>
                      <LuInfo />
                      Task Details
                    </HStack>
                  </Collapsible.Trigger>
                  <Collapsible.Content>
                    <Box px="4" pb={2} borderWidth="1px">
                      {getFileTypeFromUrl(item.media_file) == "image" && <Image src={item.media_file} mt={2} borderRadius={"lg"} width={"100%"} />}
                      {getFileTypeFromUrl(item.media_file) == "video" && (
                        <video width="100%" controls>
                          <source src={item.media_file} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      )}
                      {item.description ? (
                        <>
                          <Text mt={2} fontSize={"16px"} fontWeight={"bold"}>
                            Description
                          </Text>
                          <Text>{item.description}</Text>
                        </>
                      ) : (
                        <Text mt={2}>No Description</Text>
                      )}
                    </Box>
                  </Collapsible.Content>
                </Collapsible.Root>

                {item.file && (
                  <Collapsible.Root>
                    <Collapsible.Trigger cursor={"pointer"} bg={"blackAlpha.800"} p={1} px={2} color={"white"} borderRadius={"lg"} mb={2}>
                      <HStack>
                        <LuDownload />
                        Downlad Files
                      </HStack>
                    </Collapsible.Trigger>
                    <Collapsible.Content>
                      <Box px="4" pb={2} borderWidth="1px">
                        <Box px="4" pb={2} mt={2}>
                          <HStack justifyContent={"space-between"}>
                            <Text width={"80%"}>{item.file}</Text>
                            <HStack>
                              <Button
                                bg={"transparent"}
                                p={0}
                                m={0}
                                onClick={() => {
                                  const link = document.createElement("a");
                                  link.href = item.file; // The file URL
                                  link.download = item.file.split("/").pop(); // Suggest file name from URL
                                  document.body.appendChild(link);
                                  link.click(); // Trigger the download
                                  document.body.removeChild(link); // Clean up
                                }}
                              >
                                <LuDownload color="MenuText" />
                              </Button>
                            </HStack>
                          </HStack>
                        </Box>
                      </Box>
                    </Collapsible.Content>
                  </Collapsible.Root>
                )}

                {status != "open" && (
                  <Collapsible.Root>
                    <Collapsible.Trigger cursor={"pointer"} bg={"blackAlpha.800"} p={1} px={2} color={"white"} borderRadius={"lg"} mb={2}>
                      <HStack>
                        <LuLogs />
                        Logs
                      </HStack>
                    </Collapsible.Trigger>
                    <Collapsible.Content>
                      <Timeline.Root size="lg" variant="subtle" maxW="md" pt={3}>
                        {[...item.task_logs.map((t) => ({ ...t, _type: "task_log" })), ...item.reviews.map((r) => ({ ...r, _type: "review" }))]
                          .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))
                          .map((item2, index) => (
                            <Timeline.Item key={index}>
                              <Timeline.Connector>
                                <Timeline.Separator />
                                <Timeline.Indicator>{item2.log_type == "report" ? <LuScrollText /> : <LuMessageSquareText />}</Timeline.Indicator>
                              </Timeline.Connector>
                              <Timeline.Content>
                                <Timeline.Title>
                                  <Avatar.Root size="2xs">
                                    <Avatar.Image src={item2.photo} />
                                    <Avatar.Fallback name={item2.first_name + " " + item2.last_name} />
                                  </Avatar.Root>
                                  {item2.first_name} {item2.last_name}
                                  <Span color="fg.muted">{item2.timestamp}</Span>
                                </Timeline.Title>
                                <Timeline.Content pb={0} gap={0}>
                                  {item2?.context.split(" ").length > 30 ? (
                                    <Box p={1} px={2} mb={2} borderRadius="md" _hover={{ bg: "gray.50" }}>
                                      <Text textAlign="left">{openLogs[index] ? item2.context : truncateWords(item2.context, 30)}</Text>

                                      <Badge mt={1} cursor="pointer" colorScheme="blue" variant="subtle" onClick={() => toggleLog(index)}>
                                        {openLogs[index] ? "Show less" : "Show more"}
                                      </Badge>
                                    </Box>
                                  ) : (
                                    <Text>{item2.context}</Text>
                                  )}

                                  <HStack gap={0}>
                                    {item2._type == "review" && (
                                      <Button bg="transparent" alignSelf="start" p={0} m={0} onClick={() => handleReviewStatus(item2, "resolved")} isDisabled={!!reviewLoading[`${item2.id}_resolved`]}>
                                        <Tooltip content="Resolved">{reviewLoading[`${item2.id}_resolved`] ? <Spinner size="xs" color="green" /> : <LuSquareCheck color="green" />}</Tooltip>
                                      </Button>
                                    )}

                                    {item2._type == "review" && (
                                      <Button
                                        bg="transparent"
                                        alignSelf="start"
                                        p={0}
                                        m={0}
                                        onClick={() => handleReviewStatus(item2, "assigned_to_admin")}
                                        isDisabled={!!reviewLoading[`${item2.id}_assigned_to_admin`]}
                                      >
                                        <Tooltip content="Assigned To Admin">
                                          {reviewLoading[`${item2.id}_assigned_to_admin`] ? <Spinner size="xs" color="MenuText" /> : <LuShieldQuestion color="MenuText" />}
                                        </Tooltip>
                                      </Button>
                                    )}

                                    {item2.log_file && (
                                      <Button
                                        bg={"transparent"}
                                        alignSelf={"start"}
                                        p={0}
                                        m={0}
                                        onClick={() => {
                                          // item2.log_file
                                          const link = document.createElement("a");
                                          link.href = item2.log_file; // The file URL
                                          link.download = item2.log_file.split("/").pop(); // Suggest file name from URL
                                          document.body.appendChild(link);
                                          link.click(); // Trigger the download
                                          document.body.removeChild(link); // Clean up
                                        }}
                                      >
                                        <Tooltip content="Download File">
                                          <LuDownload color="MenuText" />
                                        </Tooltip>
                                      </Button>
                                    )}
                                    {item2.progress && (
                                      <Slider.Root gap={0} width={"full"} defaultValue={[item2?.progress ? item2?.progress : 0]} mb={2} disabled>
                                        <Slider.Label fontSize={"13px"}>Progress Rate: {item2?.progress} %</Slider.Label>
                                        <Slider.Control>
                                          <Slider.Track>
                                            <Slider.Range />
                                          </Slider.Track>
                                          <Slider.Thumbs />
                                        </Slider.Control>
                                      </Slider.Root>
                                    )}
                                    {item2.bbox && (
                                      <Button
                                        bg={"transparent"}
                                        alignSelf={"start"}
                                        p={0}
                                        m={0}
                                        onClick={() => {
                                          showBBoxOnMap(viewerRef.current, item2.bbox);
                                        }}
                                      >
                                        <Tooltip content="Focus">
                                          <LuFocus color="MenuText" />
                                        </Tooltip>
                                      </Button>
                                    )}
                                  </HStack>
                                  {Object.hasOwn(item2, "replies") &&
                                    (() => {
                                      // make a stable key for this log item
                                      const rKey = `${item2.id ?? index}`;
                                      const replies = normalizeReplies(item2.replies); // normalize any shape

                                      return (
                                        <>
                                          {/* toggle button */}
                                          <HStack>
                                            <Button size="xs" variant="ghost" bg="transparent" p={1} m={0} onClick={() => toggleReplies(rKey)}>
                                              {/* keep it simple: icon + count */}
                                              <HStack gap={1}>
                                                <LuMessageSquareText />
                                                <Text fontSize="sm">Replies ({replies.length})</Text>
                                              </HStack>
                                            </Button>
                                          </HStack>

                                          {/* collapsed content */}
                                          {openReplies[rKey] && (
                                            <>
                                              {replies.length === 0 ? (
                                                <Text fontSize="sm" color="fg.muted" mt={1}>
                                                  No replies
                                                </Text>
                                              ) : (
                                                replies.map((r, rIdx) => (
                                                  <Timeline.Item key={`${rKey}-reply-${r.id ?? rIdx}`}>
                                                    <Timeline.Connector>
                                                      <Timeline.Separator />
                                                      <Timeline.Indicator>
                                                        {/* simple avatar fallback */}
                                                        <Avatar.Root size="2xs">
                                                          <Avatar.Fallback name={r.username} />
                                                        </Avatar.Root>
                                                      </Timeline.Indicator>
                                                    </Timeline.Connector>

                                                    <Timeline.Content>
                                                      <Timeline.Title>
                                                        {r.username} <Span color="fg.muted">{r.timestamp}</Span>
                                                      </Timeline.Title>
                                                      <Timeline.Content pb={0} gap={0}>
                                                        <Text>{r.context}</Text>
                                                      </Timeline.Content>
                                                    </Timeline.Content>
                                                  </Timeline.Item>
                                                ))
                                              )}

                                              {/* reply input (enabled placeholder; wire later) */}
                                              {/* reply input */}
                                              <Timeline.Item mt={2}>
                                                <Timeline.Connector>
                                                  <Timeline.Separator />
                                                  <Timeline.Indicator>
                                                    <Avatar.Root size={"full"}>
                                                      <Avatar.Fallback name={userData?.user?.first_name + " " + userData?.user?.last_name} />
                                                      <Avatar.Image src={userData?.photos} />
                                                    </Avatar.Root>
                                                  </Timeline.Indicator>
                                                </Timeline.Connector>

                                                <Timeline.Content gap="4" mt="-1" w="full">
                                                  <HStack gap={0}>
                                                    <Input
                                                      size="sm"
                                                      placeholder="Reply ..."
                                                      value={replyInputs[rKey] ?? ""}
                                                      onChange={(e) => {
                                                        currentReplyKeyRef.current = rKey; // track key
                                                        setReplyInputs((p) => ({ ...p, [rKey]: e.target.value }));
                                                      }}
                                                    />
                                                    <Button
                                                      bg={"transparent"}
                                                      p={0}
                                                      m={0}
                                                      onClick={() => {
                                                        const text = (replyInputs[rKey] ?? "").trim();
                                                        if (!text) return; // guard
                                                        handleSubmitReply(item2.id, text, item.id); // pass parent task id + text
                                                      }}
                                                      isDisabled={!(replyInputs[rKey] ?? "").trim()}
                                                    >
                                                      <LuSendHorizontal color="MenuText" />
                                                    </Button>
                                                  </HStack>
                                                </Timeline.Content>
                                              </Timeline.Item>
                                            </>
                                          )}
                                        </>
                                      );
                                    })()}
                                </Timeline.Content>
                              </Timeline.Content>
                            </Timeline.Item>
                          ))}

                        <Timeline.Item>
                          <Timeline.Connector>
                            <Timeline.Separator />
                            <Timeline.Indicator>
                              <Avatar.Root size={"full"}>
                                <Avatar.Fallback name={userData?.user?.first_name + " " + userData?.user?.last_name} />
                                <Avatar.Image src={userData?.photos} />
                              </Avatar.Root>
                            </Timeline.Indicator>
                          </Timeline.Connector>
                          <Timeline.Content gap="4" mt="-1" w="full" bg={"blackAlpha.100"} p={1} px={3} rounded={"md"}>
                            <HStack gap={0}>
                              <Input
                                size="sm"
                                placeholder="Add comment..."
                                value={commentInput}
                                onChange={(v) => {
                                  setCommentInput(v.target.value);
                                }}
                              />
                              <Button
                                bg={"transparent"}
                                p={0}
                                m={0}
                                onClick={() => {
                                  addCommentLog(item);
                                }}
                              >
                                <LuSendHorizontal color="MenuText" />
                              </Button>
                            </HStack>
                          </Timeline.Content>
                        </Timeline.Item>
                      </Timeline.Root>
                    </Collapsible.Content>
                  </Collapsible.Root>
                )}
              </Card.Body>
            </Box>
          </Card.Root>
        ))}
    </>
  );
};

const TaskManagement = () => {
  // state
  const city = useAppStore((s) => s.city);
  const isAdminTaskListOpen = useAppStore((s) => s.isAdminTaskListOpen);
  const reviewTitle = useAppStore((s) => s.reviewTitle);
  const originalCameraControls = useAppStore.getState().originalCameraControls;
  const viewerRef = useAppStore((s) => s.viewerRef);
  const userData = useAppStore((s) => s.userData);
  const userType = useAppStore((s) => s.userType);
  const tasks = useAppStore((s) => s.tasks);
  const selectedProject = useAppStore((s) => s.selectedProject);

  // setters
  const setIsAdminTaskListOpen = useAppStore.getState().setIsAdminTaskListOpen;
  const setTasks = useAppStore.getState().setTasks;

  const [newTaskButtonEnable, setNewTaskButtonEnable] = useState(true);
  const [dailyReportShowDialog, setDailyReportShowDialog] = useState(false);
  const [newTaskDialog, setNewTaskDialog] = useState(false);
  const [polygon, setpolygon] = useState(null);

  const [isProgress, setIsProgress] = useState(false);
  const [formContext, setFormContext] = useState("");
  const [formCity, setFormCity] = useState("");
  const [formTitle, setFormTitle] = useState("");

  const [isRefreshProgress, setIsRefreshProgress] = useState(false);

  const [cityOptions, setCityOptions] = useState(
    createListCollection({
      items: [],
    })
  );
  useEffect(() => {
    if (city) {
      let temp = [];
      for (const key in city) {
        temp.push({ label: city[key].name, value: city[key].name.toLowerCase() });
      }
      setCityOptions(
        createListCollection({
          items: temp,
          itemToString: (item) => item.label,
          itemToValue: (item) => item.value,
        })
      );
    }
  }, [city]);

  const [titleOptions, setTitleOptions] = useState(
    createListCollection({
      items: [],
    })
  );

  useEffect(() => {
    if (reviewTitle.length > 0) {
      try {
        const source = Array.isArray(reviewTitle) ? reviewTitle : [];

        const groupedByCategory = source.reduce((acc, item) => {
          const cat = item?.category ?? "uncategorized"; // fallback in case of missing category
          if (!acc[cat]) acc[cat] = [];
          acc[cat].push(item);
          return acc;
        }, {});

        let items = Object.entries(groupedByCategory).map(([category, arr]) => {
          const options = arr
            .slice()
            .sort((a, b) => a.type.localeCompare(b.type))
            .map((it) => ({
              label: it.type,
              value: it.type_short,
            }));

          return { category, options };
        });

        items = items.sort((a, b) => a.category.localeCompare(b.category));

        setTitleOptions(
          createListCollection({
            items,
          })
        );
      } catch (e) {}
    }
  }, [reviewTitle]);

  const startNewTask = () => {
    if (!selectedProject) {
      showToast("No project selected", Type.NOTIFICATION.WARNING);
      return;
    }

    setNewTaskButtonEnable(!newTaskButtonEnable);
    showToast("Select a range", Type.NOTIFICATION.INFO);

    const handler = enableRectangleDrawing(
      viewerRef.current,
      originalCameraControls,
      (bounds) => {
        const { west, south, east, north } = bounds;

        const polygonCoords = [
          { lon: west, lat: south },
          { lon: east, lat: south },
          { lon: east, lat: north },
          { lon: west, lat: north },
          { lon: west, lat: south },
        ];

        handler.destroy();
        setpolygon(polygonCoords);

        setNewTaskButtonEnable(true);
        setNewTaskDialog(true);
        deleteDrawingForSelect(viewerRef.current);
      },
      false
    );
  };

  const getTasks = () => {
    setIsProgress(true);
    setIsRefreshProgress(true);
    let serviceData = {};

    let temp = {};
    if (formContext) {
      temp.description = formContext;
    }
    if (formCity) {
      temp.city = formCity;
    }
    if (formTitle) {
      temp.task_title = formTitle;
    }
    serviceData.params = JSON.stringify(temp);

    serviceGetTask(serviceData, userData.token)
      .then((res) => {
        setIsProgress(false);
        setIsRefreshProgress(false);
        if (res.data.status === "success") {
          setTasks(res.data.tasks);
        } else {
          showToast(res.data.message, Type.NOTIFICATION.WARNING);
        }
      })
      .catch((err) => {
        setIsRefreshProgress(false);
        setIsProgress(false);
        console.error("Error", err);
        showToast(err, Type.NOTIFICATION.ERROR);
      });
  };

  const resetForm = () => {
    setFormContext("");
    setFormCity("");
    setFormTitle("");
  };

  const [isFilterOpen, setIsFilterOpen] = useState(false);

  return (
    <>
      <Popover.Root
        positioning={{ placement: "left-start" }}
        open={isAdminTaskListOpen}
        onOpenChange={(e) => {
          setIsAdminTaskListOpen(e.open);
        }}
        closeOnInteractOutside={false}
      >
        <Popover.Trigger asChild>
          <Button p={2} width={"45px"} height={"45px"} bg={isAdminTaskListOpen ? "green" : "white"} color={isAdminTaskListOpen ? "white" : "MenuText"}>
            <Tooltip content={"Task Management"} width={"full"} height={"full"}>
              <LuLayoutList color={isAdminTaskListOpen ? "white" : "MenuText"} />
            </Tooltip>
          </Button>
        </Popover.Trigger>
        <Portal>
          <Popover.Positioner>
            <Popover.Content width={"540px"} height={"80vh"} zIndex={1001} borderRadius={10} mt={"-50px"}>
              <Popover.Arrow mt={"25px"} />
              <Popover.Header mb={3}>
                <Popover.Title fontSize={"xl"} width={"full"} mb={5}>
                  Task Management
                </Popover.Title>
                {(userType.includes(Type.ROLE.ADMIN) || userType.includes(Type.ROLE.SUPER_ADMIN)) && (
                  <SimpleGrid columns={6} gap={1} my={2}>
                    <Tooltip content={"Add New Task"}>
                      <Button variant="outline" size="2xl" p={0} height="65px" onClick={startNewTask} colorPalette={""} disabled={!newTaskButtonEnable}>
                        <LuPlus size={20} />
                      </Button>
                    </Tooltip>
                    <Tooltip content={"Refresh Task List"}>
                      <Button variant="outline" size="2xl" p={0} height="65px" onClick={getTasks} colorPalette={""}>
                        {isRefreshProgress ? <Spinner size={"sm"} /> : <LuRefreshCcw size={20} />}
                      </Button>
                    </Tooltip>
                  </SimpleGrid>
                )}
                <Collapsible.Root
                  open={isFilterOpen}
                  onOpenChange={(e) => {
                    setIsFilterOpen(e.open);
                  }}
                >
                  <Collapsible.Trigger variant="outline" size={"2xl"} p={2} mb={1} cursor={"pointer"} width={"full"} bg={"blackAlpha.200"} borderRadius={"md"}>
                    <HStack justifyContent={"space-between"}>
                      <HStack gap={2}>
                        <LuFilter size={20} />
                        <Text fontSize={"17px"}>Filter</Text>
                      </HStack>
                      {isFilterOpen ? <LuArrowUp size={20} /> : <LuArrowDown size={20} />}
                    </HStack>
                  </Collapsible.Trigger>
                  <Collapsible.Content>
                    <Box padding="4" borderWidth="1px">
                      <Field.Root mt={2}>
                        <Box pos="relative" w="full">
                          <Select.Root
                            collection={cityOptions}
                            size="sm"
                            width="full"
                            value={[formCity]}
                            onValueChange={(v) => {
                              setFormCity(v.value[0]);
                            }}
                          >
                            <Select.HiddenSelect />

                            <Select.Control>
                              <Select.Trigger>
                                <Select.ValueText placeholder={"City"} />
                              </Select.Trigger>
                              <Select.IndicatorGroup>
                                <Select.ClearTrigger />
                                <Select.Indicator />
                              </Select.IndicatorGroup>
                            </Select.Control>

                            <Select.Positioner>
                              <Select.Content height={"200px"}>
                                {cityOptions.items.map((item) => (
                                  <Select.Item item={item} key={item.value}>
                                    {item.label}
                                    <Select.ItemIndicator />
                                  </Select.Item>
                                ))}
                              </Select.Content>
                            </Select.Positioner>
                          </Select.Root>
                          <Field.Label css={floatingStyles}>
                            <LuTowerControl /> City
                          </Field.Label>
                        </Box>
                      </Field.Root>
                      <Field.Root mt={5}>
                        <Box pos="relative" w="full">
                          <Select.Root
                            collection={titleOptions}
                            size="sm"
                            width="full"
                            onValueChange={(v) => {
                              setFormTitle(v.value[0]);
                            }}
                          >
                            <Select.HiddenSelect />

                            <Select.Control>
                              <Select.Trigger>
                                <Select.ValueText placeholder={formTitle ? formTitle : "Select Title"} />
                              </Select.Trigger>
                              <Select.IndicatorGroup>
                                <Select.ClearTrigger />
                                <Select.Indicator />
                              </Select.IndicatorGroup>
                            </Select.Control>

                            <Select.Positioner>
                              <Select.Content height={"200px"}>
                                <ReviewTitleOptions collection={titleOptions} />
                              </Select.Content>
                            </Select.Positioner>
                          </Select.Root>
                          <Field.Label css={floatingStyles}>
                            <LuText /> Title
                          </Field.Label>
                        </Box>
                      </Field.Root>
                      <Field.Root mt={3}>
                        <Box pos="relative" w="full">
                          <Textarea
                            className="peer"
                            placeholder=""
                            type="text"
                            rows={5}
                            value={formContext}
                            onChange={(v) => {
                              setFormContext(v.target.value);
                            }}
                          />
                          <Field.Label css={floatingStyles}>
                            <LuText /> Context
                          </Field.Label>
                        </Box>
                      </Field.Root>
                      <Button mt={2} onClick={getTasks}>
                        {isProgress ? <Spinner size={"sm"} /> : "Load"}
                      </Button>
                      <Button mt={2} ml={2} onClick={resetForm} colorPalette={"red"}>
                        Reset
                      </Button>
                    </Box>
                  </Collapsible.Content>
                </Collapsible.Root>
              </Popover.Header>
              <Popover.Body p={2} overflow={"auto"}>
                {/* Tabs for task categories */}
                <Tabs.Root key="line" width="full" defaultValue="open" variant="line">
                  <Tabs.List>
                    <Tabs.Trigger value="open">
                      <LuDiamondPlus />
                      New Tasks
                    </Tabs.Trigger>
                    <Tabs.Trigger value="in_progress">
                      <LuLoader />
                      In Progress
                    </Tabs.Trigger>
                    <Tabs.Trigger value="review">
                      <LuHourglass />
                      Review
                    </Tabs.Trigger>
                    <Tabs.Trigger value="completed">
                      <LuSquareCheckBig />
                      Completed
                    </Tabs.Trigger>
                  </Tabs.List>

                  {/* Assigned tasks tab */}
                  <Tabs.Content value="open">
                    <TaskCard data={tasks} status={"open"} reportDialogState={[dailyReportShowDialog, setDailyReportShowDialog]} getTasks={getTasks} />
                  </Tabs.Content>

                  {/* Unassigned tasks tab */}
                  <Tabs.Content value="in_progress">
                    <TaskCard data={tasks} status={"in_progress"} reportDialogState={[dailyReportShowDialog, setDailyReportShowDialog]} getTasks={getTasks} />
                  </Tabs.Content>

                  {/* Unassigned tasks tab */}
                  <Tabs.Content value="review">
                    <TaskCard data={tasks} status={"review"} reportDialogState={[dailyReportShowDialog, setDailyReportShowDialog]} getTasks={getTasks} />
                  </Tabs.Content>

                  {/* Completed tasks tab */}
                  <Tabs.Content value="completed">
                    <TaskCard data={tasks} status={"completed"} reportDialogState={[dailyReportShowDialog, setDailyReportShowDialog]} getTasks={getTasks} />
                  </Tabs.Content>
                </Tabs.Root>
              </Popover.Body>
            </Popover.Content>
          </Popover.Positioner>
        </Portal>
      </Popover.Root>
      <TaskManagementNewTask state={[newTaskDialog, setNewTaskDialog]} polygonState={[polygon, setpolygon]} />
      <TaskManagementDailyReport state={[dailyReportShowDialog, setDailyReportShowDialog]} />
    </>
  );
};

export default TaskManagement;
